jQuery(document).ready(function ($) {

    var module_name = 'modular_module';
});